/**
 * Import Lib
 */

import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
/**
 * Import Context
 */

import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * import assets
 */

import results from "mocks";

/**
 * import containers & components
 */

import Layout__container from "containers/layout/container/layout__container";
import Layout__content from "containers/layout/content/layout__content";
import { Content__heading, Content__condition } from "components/content/content";
import { Button__back, Button__print } from "components/button/button";
import { Shadow__container } from "components/shadow/shadow";
import { Table__table } from "components/table/table";

const Container = styled(Shadow__container)`
  position: relative;
  overflow: hidden;
`;
const Wrapper = styled(Shadow__container)`
  overflow-x: scroll;
`;

/**
 * @name Results
 */

const Results = () => {
  const { content, c } = useContext(ContentContext);
  const { getChoices } = useContext(AppContext);
  const history = useHistory();
  // const choices = results.results;
  const choices = getChoices();
  const back = () => {
    history.push("/products");
  };
  const title =
    choices.length !== 1
      ? `${c("home.results.title1")} ${choices.length} ${c("home.results.title2")}`
      : c("home.results.titleSingular");

  const [isLoading, setIsLoading] = useState(true);
  let resultsRef = useRef();
  useEffect(() => {
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView();
    }
  }, [isLoading])

  return (
    <Layout__container pageName={content.results.config.page_name}>
      <div ref={resultsRef}></div>
      <Layout__content>
        <Content__heading title={title} subtitle={c("home.results.subtitle")} />
        <Button__back onClick={back} title={c("home.results.selection")} />
        <Button__print />
        <Container>
          <Wrapper>
            <Table__table data={choices} />
          </Wrapper>
        </Container>
        <Content__condition content={c("home.products.condition")} />
      </Layout__content>
    </Layout__container>
  );
};

export default Results;
